// Grille tarifaire par défaut — MOCKED (localStorage), appliquée automatiquement.
// Les prix d'achat d'olives (prix de base de l'huile, prix fixe) ne figurent pas
// ici : ils sont négociés et saisis opération par opération.
const KEY = 'oliva.tarifs';

export const TARIFS_DEFAUT = {
  triturationNoble: 0.18, // TND / kg d'olives — prestation client, filière noble (Extra / Vierge)
  triturationLampante: 0.18, // TND / kg d'olives — prestation client, filière lampante
  trituration: 0.18, // clé historique conservée comme repli
  retenue: 2, // % d'huile retenue au profit de l'huilerie (bonus & garde)
  calamitesDefaut: false, // retenue Fonds des Calamités (1 %) précochée sur les nouveaux achats
  prixMarcheHuile: 11.5, // TND / kg — référence marché huile noble (écarts, verdicts)
  prixMarcheLampante: 7, // TND / kg — référence marché huile lampante
  minimumActif: true, // minimum de facturation de la prestation de trituration (clients)
  minimumSeuilKg: 500, // kg facturés au minimum, au tarif applicable au lot
};

const positif = (valeur, defaut) => (Number(valeur) > 0 ? Number(valeur) : defaut);

export function getTarifs() {
  const raw = localStorage.getItem(KEY);
  const stocke = raw ? JSON.parse(raw) : null;
  // Migration douce : l'ancien prix unique sert de repli aux deux nouveaux tarifs.
  const legacy = positif(stocke?.trituration, TARIFS_DEFAUT.trituration);
  const noble = positif(stocke?.triturationNoble, legacy);
  const lampante = positif(stocke?.triturationLampante, legacy);
  return {
    triturationNoble: noble,
    triturationLampante: lampante,
    trituration: noble,
    retenue: stocke?.retenue ?? TARIFS_DEFAUT.retenue,
    calamitesDefaut: stocke?.calamitesDefaut ?? TARIFS_DEFAUT.calamitesDefaut,
    prixMarcheHuile: stocke?.prixMarcheHuile ?? TARIFS_DEFAUT.prixMarcheHuile,
    prixMarcheLampante: stocke?.prixMarcheLampante ?? TARIFS_DEFAUT.prixMarcheLampante,
    minimumActif: stocke?.minimumActif ?? TARIFS_DEFAUT.minimumActif,
    minimumSeuilKg: positif(stocke?.minimumSeuilKg, TARIFS_DEFAUT.minimumSeuilKg),
  };
}

export function setTarifs(patch) {
  const actuel = getTarifs();
  const noble = positif(patch.triturationNoble, actuel.triturationNoble);
  const lampante = positif(patch.triturationLampante, actuel.triturationLampante);
  const next = {
    triturationNoble: noble,
    triturationLampante: lampante,
    trituration: noble,
    retenue: patch.retenue === undefined ? actuel.retenue : Number(patch.retenue) || 0,
    calamitesDefaut:
      patch.calamitesDefaut === undefined ? actuel.calamitesDefaut : patch.calamitesDefaut === true,
    prixMarcheHuile:
      patch.prixMarcheHuile === undefined ? actuel.prixMarcheHuile : Number(patch.prixMarcheHuile) || 0,
    prixMarcheLampante:
      patch.prixMarcheLampante === undefined ? actuel.prixMarcheLampante : Number(patch.prixMarcheLampante) || 0,
    // Minimum de facturation : paramètres réservés à l'Administrateur (contrôle serveur).
    minimumActif: patch.minimumActif === undefined ? actuel.minimumActif : patch.minimumActif === true,
    minimumSeuilKg: positif(
      patch.minimumSeuilKg === undefined ? actuel.minimumSeuilKg : patch.minimumSeuilKg,
      TARIFS_DEFAUT.minimumSeuilKg
    ),
  };
  if (next.retenue < 0 || next.retenue > 100) return actuel;
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event('tarifs-maj'));
  return next;
}

// Tarif de trituration appliqué automatiquement selon la filière du lot.
// Accepte un identifiant de qualité ('extra_vierge' | 'vierge' | 'lampante')
// ou directement une famille ('noble' | 'lampante'). Le tarif client est facultatif.
export const tarifTriturationPour = (qualiteOuFamille, contactClient = null) => {
  const personnalise = contactClient?.tarifTriturationPersonnalise;
  if (contactClient?.type !== 'personnel' && contactClient?.estClient !== false
      && typeof personnalise === 'number' && Number.isFinite(personnalise) && personnalise > 0) {
    return personnalise;
  }
  const t = getTarifs();
  return String(qualiteOuFamille) === 'lampante' ? t.triturationLampante : t.triturationNoble;
};
